import { number, shape, string } from 'prop-types';
import React from 'react';

const CardContent = ({ details: { title, percentage, itemCount }, additionalClasses = '' }) => {
	return (
		<div className={`trend-card-content ${additionalClasses}`}>
			<p className="design-title semibold-14">{title}</p>
			<ul className="common-list-component mt-1">
				<li>
					<span className="status blue-3 radius">{percentage}</span>
				</li>
				<li>{itemCount?.toLocaleString()} Items</li>
			</ul>
		</div>
	);
};

CardContent.propTypes = {
	details: shape({
		title: string.isRequired,
		percentage: string.isRequired,
		itemCount: number.isRequired
	}),
	additionalClasses: string,
	tooltipSize: number
};

export default CardContent;
